import React, { useEffect } from "react";
import { DataTypes } from "../../../../common/constants";
import SlbButton from "../../../controls/button";
import DataListing from "../../../listing/listing";
import {
  setButtonsData,
  setButtonsText,
} from "../../../../store/banner/bannerSlice";
import { useDispatch } from "react-redux";
import { getConfiguredLabel } from "../../../../common/commonHelper";
import {
  addButton,
  addNetworkUploadButton,
  addNetworkUploadMessage,
  addNetworkUploadTitle,
  adminPage,
  cancelButton,
  deleteButton,
  deleteMessage,
  deleteNetworkUploadMessage,
  deleteNetworkUploadTitle,
  deleteNotAllowedMessage,
  DocumentsPage,
  editNetworkUploadMessage,
  editNetworkUploadTitle,
  networkTabName,
  saveButton,
} from "../../../../common/labelConstants";

export const NetworkUpload = (props) => {
  const dispatch = useDispatch();
  const handleRowClassName = (rowData) => {
    // const rowClassName = rowData?.active?.hasOwnProperty("No")
    // if (rowClassName) {
    //     return "admin_rowStyle"
    // }
  };

  const addNetworkUpload = () => {
    dispatch(setButtonsData(true));
  };

  const addNetworkText = getConfiguredLabel(adminPage, addNetworkUploadButton);
  const bannerContent = {
    tabName: getConfiguredLabel(adminPage, networkTabName),
    actionsJSX: (
      <>
        <div className="cancel-save-btns">
          <SlbButton className="calcel_btn " onClick={addNetworkUpload}> 
            {addNetworkText}
          </SlbButton>
        </div>
      </>
    ),
  };
  
  useEffect(() => {
    dispatch(setButtonsText(bannerContent));
    return () => {
      dispatch(setButtonsText(""));
    };
  }, []);

  const actionToaster = {
    add: {
      title: getConfiguredLabel(adminPage, addNetworkUploadTitle),
      message: getConfiguredLabel(adminPage, addNetworkUploadMessage),
    },
    edit: {
      title: getConfiguredLabel(adminPage, editNetworkUploadTitle),
      message: getConfiguredLabel(adminPage, editNetworkUploadMessage),
    },
    delete: {
      title: getConfiguredLabel(adminPage, deleteNetworkUploadTitle),
      message: getConfiguredLabel(adminPage, deleteNetworkUploadMessage),
      deleteNotAllowedMessage: getConfiguredLabel(
        adminPage,
        deleteNotAllowedMessage
      ),
    },
  };
  return (
    <div className="upload_documents">
      <div className="slb-container-fluid">
        <DataListing
          paginator={true}
          dataType_id={DataTypes.Network.id}
          templateName={"FeatureConfiguration"}
          rowClass={handleRowClassName}
          actionToaster={actionToaster}
          pageActionsInfo={{
            add: {
              title: getConfiguredLabel(adminPage, addNetworkUploadTitle),
              message: "",
              actions: {
                ok: { label: getConfiguredLabel(DocumentsPage, addButton) },
                cancel: {
                  label: getConfiguredLabel(DocumentsPage, cancelButton),
                },
              },
            },
            edit: {
              title: getConfiguredLabel(adminPage, editNetworkUploadTitle),
              message: "",
              actions: {
                ok: { label: getConfiguredLabel(DocumentsPage, saveButton) },
                cancel: {
                  label: getConfiguredLabel(DocumentsPage, cancelButton),
                },
              },
            },
            delete: {
              title: getConfiguredLabel(adminPage, deleteNetworkUploadTitle),
              message: getConfiguredLabel(DocumentsPage, deleteMessage),
              actions: {
                ok: { label: getConfiguredLabel(DocumentsPage, deleteButton) },
                cancel: {
                  label: getConfiguredLabel(DocumentsPage, cancelButton),
                },
              },
            },
          }}
          renderHeaderAreaLeft={({ pagingInfo }) => {
            return <></>;
          }}
          renderHeaderAreaRight={({
            btn_delete,
            filter_global,
            orderBy_icon,
            sortBy_dropdown,
            add_item,
            selectedRows,
          }) => {
            return <>{btn_delete}</>;
          }}
          dataKey={"sourceName"}
        />
        
      </div>
    </div>
  );
};
